import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Subject } from "rxjs/internal/Subject";
import { HttpService, CodehelpService } from "virtue-form";
import {
  Answer,
  FormResponse,
  NpcCalculation,
  ServiceConfig,
} from "virtue-form/lib/modals/modal";
import {
  FormData,
  Question,
  StepperInfo,
  Uiconfig,
} from "virtue-form/lib/modals/modal";

import {
  stateAnswerModel,
  IntrestPageAnswer,
  filter,
  stateInOutStateCode,
  searchCollegeList,
  decryptUser,
} from "../../models/answerMapModel";
import { Router } from "@angular/router";
import { ValueConverter } from "@angular/compiler/src/render3/view/template";

@Injectable({
  providedIn: "root",
})
export class GlobalVarService {
  seFormFilledId: string = "";
  formSubmitId: string = "";
  formResponse!: FormResponse;
  orgRef: any = {};
  myAccountPageUrl: string;
  previousPageUrl: number;
  isInternatinalStudent: boolean = false;
  saveChangedDeduct: boolean = false;
  tagIndexMap: Map<Number, Number> = new Map();
  answerMap: Map<Number, Answer> = new Map();
  preSelectedAnswerMap: Map<Number, Answer> = new Map();
  saveChangedAnswerMap: Map<Number, Answer> = new Map();
  feedBackFormAnswerMap: Map<Number, Answer> = new Map();
  saveChangesResultPage = new BehaviorSubject(false); //new Subject<boolean>();

  checkedUSMap = new BehaviorSubject(null); //new Subject<null>();
  AllcheckedUSMap = new BehaviorSubject(null); //new Subject<null>();
  unCheckedUSMap = new BehaviorSubject(null); //new Subject<null>();
  UnCheckedReciprocityMap = new BehaviorSubject(null);
  checkedReciprocityMap = new BehaviorSubject(null);

  logoUrl: string;
  userLoginDetails: any = {};
  searchSelectedCollegeList: Array<any> = [];
  collegeSortBy: string = "By_Cost";

  ReciprocitySelectedStateList: Array<any> = [];
  selectedUniversityList: Array<any> = [];
  filterSelected: Map<string, filter> = new Map();
  interestPageAnswerMap: Map<string, IntrestPageAnswer> = new Map();
  CollegeSelctionList: Map<string, IntrestPageAnswer> = new Map();
  affinityQuestionAnswer: Map<string, any> = new Map();
  isShowLogin: boolean = false;
  searchCollegeList: Map<string, searchCollegeList> = new Map();
  isSelectionByFilters: boolean = false;
  deleteBy: string = "";
  ProductKey: string = "";
  handleSelectionCollege: boolean = false;
  universitySelectedValueMap: Map<string, string> = new Map();
  StateInOutMap: Map<string, stateInOutStateCode> = new Map();
  stateAnswerModel: Map<string, stateAnswerModel> = new Map();
  isLoading: boolean = false;
  uiConfig!: Uiconfig;
  serviceConfig!: ServiceConfig;
  AddWatchList: any;
  basepath: string = "";
  orgname: string = "";
  TimeDiffrence: any = "";
  resetwidth: any = "";
  getAllStateList: Map<string, any> = new Map();
  loginToken!: any;
  top5SubscriptionDashboardRequestData: any = {};
  isLoginAsCounselor: any = {};
  isLoginFromDashboard: any = {};
  submissionReportLink: any;
  decryptUser: decryptUser;
  stepper: StepperInfo = { page: 0 };
  extraPagestepper: StepperInfo = { page: 0 };

  public formId: string = "";
  serviceType: string = "";
  answerdata: Array<Answer> = [];
  calculatedData!: NpcCalculation;
  formReqData!: FormData;
  feedBackFormData!: FormData;
  formFilledSubmitID: string = "";
  isTokenLogin: boolean = false;
  hiddenFields: Array<Question> = [];
  pageChange: Subject<StepperInfo> = new Subject<StepperInfo>();
  organizationLoaded = new BehaviorSubject(false);
  saveChanges = new BehaviorSubject(false);
  alreadyOrganizationLoaded = new BehaviorSubject(false);
  isLoadSaveData = new BehaviorSubject(false);
  collegeFilterIsSave: boolean = false;
  isOrgLoaded: boolean = false;
  LoginShowPopup: boolean = true;
  autoRedirect: boolean = true;
  submitFrom: Subject<number> = new Subject<number>();

  isSubscribe = false;
  responsiveContentShowAndHide = new BehaviorSubject(true);
  handleExtraPage: Subject<StepperInfo> = new Subject<StepperInfo>();
  PriceList: any[] = [];

  change(val: number) {
    this.stepper.page = val;
    this.pageChange.next(this.stepper);
  }

  constructor(
    private httpser: HttpService,
    private codehelp: CodehelpService,
    private router: Router
  ) {}

  getHost() {
    return this.httpser.getHost();
  }

  saveChangeDeduct(val: boolean) {
    this.saveChangedDeduct = val;
    this.saveChanges.next(val);
  }

  informSubmit(val: number) {
    this.submitFrom.next(val);
  }

  hanleOrganizationLoading(val: boolean) {
    this.isOrgLoaded = true;
    this.organizationLoaded.next(val);
  }

  subscribeUSMapForChecked(val: any) {
    this.isSubscribe = true;
    this.checkedUSMap.next(val);
    this.checkedUSMap.next(null);
  }

  AllsubscribeUSMapForChecked(val: any) {
    this.isSubscribe = true;
    this.AllcheckedUSMap.next(val);
    this.AllcheckedUSMap.next(null);
  }

  subscribeUSMapForUnChecked(val: any) {
    this.isSubscribe = true;
    this.unCheckedUSMap.next(val);
    this.unCheckedUSMap.next(null);
  }

  subscribeReciprocityMapForChecked(val: any) {
    this.isSubscribe = true;
    this.checkedReciprocityMap.next(val);
    this.checkedReciprocityMap.next(null);
  }

  subscribeReciprocityMapForUnChecked(val: any) {
    this.isSubscribe = true;
    this.UnCheckedReciprocityMap.next(val);
    this.UnCheckedReciprocityMap.next(null);
  }

  isNotOrganizationLoading(val: boolean) {
    this.alreadyOrganizationLoaded.next(val);
    // this.alreadyOrganizationLoaded.next(val);
  }

  redirectPage(page: number, org: boolean, loadedOrg: boolean, save: boolean) {
    // if(page==2)
    // {
    //   this.handleSaveData(save);
    // }

    this.loadOrganization(org, loadedOrg, save);
    this.change(page);
    this.router.navigate(["/home/steps/" + Number(page)]);
  }

  resetLoadOrg() {
    this.change(0);
    this.isNotOrganizationLoading(true);
    this.hanleOrganizationLoading(false);
    this.handleSaveData(false);
  }

  loadOrganization(org: boolean, loadedOrg: boolean, save: boolean) {
    this.isNotOrganizationLoading(org);
    this.hanleOrganizationLoading(loadedOrg);
  }

  handleSaveData(val: boolean) {
    this.collegeFilterIsSave = val;
    this.isLoadSaveData.next(val);
  }

  setProviderId(id: string) {
    // this.codehelp.setSessionStoreValue('providerID',id);
    this.codehelp.setProviderID(id);
    // this.codehelp.setStoreValue('providerID','423a4ec5-6dc7-4073-88de-ea61ffb48fc6');
  }
  handleSaveChanges(val: boolean) {
    this.saveChangesResultPage.next(val);
  }

  initialiseStateMapSubjectBehaviour() {
    // this.checkedReciprocityMap.next(null);
    // this.unCheckedUSMap.next(null);
    // this.checkedUSMap.next(null);
    // this.UnCheckedReciprocityMap.next(null);
  }
}
